import { set } from './storage';

const CHANEL_PREFIX = 'naighlojeckmcdjnoiaelgmijbaplobm/'; // ext id

export const ACTIONS = {
  RELOAD_USER: 'user/reload',
};

function getKey(message) {
  return `${CHANEL_PREFIX}${message}`;
}

export const broadcast = (message, data) => {
  const timestamp = Date.now();
  const dataToSave = {
    data,
    timestamp,
  };
  set(getKey(message), dataToSave);
};

export const on = (message, cb) => {
  function getter(event) {
    if (event.key === getKey(message)) {
      if (event.newValue !== null) {
        const { data } = JSON.parse(event.newValue);
        cb(data);
      }
    }
  }

  window.addEventListener('storage', getter);
  return () => window.removeEventListener('storage', getter);
};
